/**
 * Custom hook to access resources (translations/labels)
 * Provides a cleaner API for components to access the Resources Context
 */

import { useResourcesContext } from '../stores/resourcesContext';

/**
 * Custom hook to access resources (translations/labels)
 */
export function useResources() {
    const { getResourceValue, isLoading } = useResourcesContext();
    return { getResourceValue, isLoading };
}
